import script from "./AdminListBox.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminListBox.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__